// Custom event names for opening AutoInsights drawers
export const OPEN_NEW_APP_VERSION_DRAWER_EVENT = 'openNewAppVersionDrawer';
export const OPEN_BROKEN_ASSETS_DRAWER_EVENT = 'openBrokenAssetsDrawer';
export const OPEN_AUTO_INSIGHTS_DRAWER_EVENT = 'auto-insights-drawer';
